module.exports = __webpack_public_path__ + "static/media/Laugo_07.733eb1fa.jpg";